import type { ShellUtilityItem } from './ShellLayoutContext'

type UtilityRailProps = {
  items: ShellUtilityItem[]
  flyoutOpen: boolean
  onSelectItem: (item: ShellUtilityItem) => void
}

export function UtilityRail({ items, flyoutOpen, onSelectItem }: UtilityRailProps) {
  if (items.length === 0) {
    return (
      <aside
        className="utility-rail utility-rail--empty"
        aria-label="Workspace tools"
        data-testid="utility-rail"
      />
    )
  }

  return (
    <aside className="utility-rail" aria-label="Workspace tools" data-testid="utility-rail">
      <nav className="utility-rail__nav" aria-label="Contextual tools">
        {items.map((item) => {
          const pressed = item.opensFlyout ? Boolean(flyoutOpen) : Boolean(item.active)

          return (
            <button
              key={item.id}
              type="button"
              className={`utility-rail__btn${pressed ? ' is-active' : ''}`}
              aria-label={item.label}
              title={item.label}
              aria-pressed={item.opensFlyout || item.active !== undefined ? pressed : undefined}
              data-testid={`utility-${item.id}`}
              disabled={item.disabled}
              onClick={() => onSelectItem(item)}
            >
              <span className="utility-rail__icon" aria-hidden="true">
                {item.icon}
              </span>
              <span className="utility-rail__tooltip" role="tooltip">
                {item.label}
              </span>
            </button>
          )
        })}
      </nav>
    </aside>
  )
}
